var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServerRgbRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dpdhl_icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39,7H9c-1.1046,0-2,.8954-2,2v6c0,1.1046,.8954,2,2,2h30c1.1046,0,2-.8954,2-2v-6c0-1.1046-.8954-2-2-2ZM13,13h-3v-2h3v2Z",
    fill: "#d70511"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39,19H9c-1.1046,0-2,.8954-2,2v6c0,1.1046,.8954,2,2,2h30c1.1046,0,2-.8954,2-2v-6c0-1.1046-.8954-2-2-2Zm-26,6h-3v-2h3v2Z",
    fill: "#d70511"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39,31H9c-1.1046,0-2,.8954-2,2v6c0,1.1046,.8954,2,2,2h30c1.1046,0,2-.8954,2-2v-6c0-1.1046-.8954-2-2-2Zm-26,6h-3v-2h3v2Z",
    fill: "#d70511"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerRgbRed);
export default __webpack_public_path__ + "static/media/server_rgb_red.09b6a4fae23d97673644343a9c8ce14a.svg";
export { ForwardRef as ReactComponent };